import React from "react"

const NavbarCollapse = ({ children, className, id}) => {
  className = `${className ? ` ${className} ` : ''}`
  
  return <div className={`collapse navbar-collapse${className}`} id={id ? `${id}` : null}>{children}</div>
}
export default NavbarCollapse
